import { useState } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import NafunElectronics from "../../assets/image/Nafun-Electronics.svg"

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export default function Navbar() {

    const [navigation, setNavigation] = useState([
        { name: 'Begining', href: '#Begining', current: false },
        { name: 'Statistics', href: '#Statistics', current: false },
        { name: 'Main benefits', href: '#MainBenefits', current: false },
        { name: 'Hardwares', href: '#Hardwares', current: false },
        { name: 'Contact us', href: '#ContactUs', current: false }
    ]);

    const setNavigationItem = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        setNavigation(
            navigation.map((item) => {
                return `http://localhost:3000/${item.href}` === event.currentTarget.href ? { ...item, current: true } : { ...item, current: false }
            })
        )
    }

    return (
        <Disclosure as="nav" className="fixed w-full flex justify-start items-center z-10 text-white">
            {({ open }) => (
                <>
                    {/* <div className={`w-full h-[80px] hover:h-[100px] md:hover:h-[80px] flex items-center pl-5 pr-12 md:px-6 lg:px-8 bg-[#1e1e1e] md:hover:text-white md:hover:bg-gradient-to-r md:hover:from-[#1e1e1e] hover:bg-transparent md:hover:bg-[#1e1e1e] hover:text-black hover:bg-gradient-radial ${open ? "!h-[700px] md:!h-[80px] hover:!h-[700px] md:hover:!h-[80px] !pt-5 md:!pt-0 !items-start md:!items-center !bg-white md:!bg-[#1e1e1e] !bg-transparent hover:!bg-transparent !text-black md:text-white hover:!text-black md:hover:!text-white  !bg-open-nav-gradient-radial md:!bg-gradient-to-r md:!from-[#1e1e1e] hover:!bg-open-nav-gradient-radial md:hover:!bg-gradient-to-r md:hover:!from-[#1e1e1e]" : ""}`}> */}
                    <div className={`w-full h-[80px] flex items-center pl-5 pr-2 md:px-6 lg:px-8 bg-[#1e1e1e] ${open ? "!h-[700px] md:!h-[80px] !pt-5 md:!pt-0 !items-start md:!items-center !bg-white md:!bg-[#1e1e1e] !bg-transparent !text-black md:text-white !bg-open-nav-gradient-radial md:!bg-gradient-to-r md:!from-[#1e1e1e] " : ""}`}>
                        <div className="w-full">
                            <div className="w-full flex justify-between items-center md:hidden">
                                <a href="https://nafun.co/" onClick={setNavigationItem}><img src={NafunElectronics} alt="NafunElectronics" className="w-[139px] h-[62px]" /></a>
                                <Disclosure.Button className="inline-flex px-8 items-center  focus:outline-none justify-center p-2">
                                    {open ? (
                                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex-1 flex items-center justify-center md:items-stretch md:justify-start">
                                <a
                                    href="https://nafun.co/"
                                    className='flex-shrink-0 flex items-center'
                                    onClick={setNavigationItem}
                                >
                                    <img
                                        className="hidden md:block w-auto"
                                        src={NafunElectronics}
                                        alt="Workflow"
                                    />
                                </a>
                                <div className="hidden md:flex md:ml-6 items-center">
                                    <div className="flex space-x-4">
                                        {navigation.map((item) => (
                                            <a
                                                key={item.name}
                                                href={item.href}
                                                className={classNames(
                                                    item.current ? 'text-shadow-navbaritem' : 'hover:text-shadow-navbaritem',
                                                    'px-3 py-2 rounded-md text-sm font-medium font-Poppins text-white flex items-center flex-col'
                                                )}
                                                aria-current={item.current ? 'page' : undefined}
                                                onClick={setNavigationItem}
                                            >
                                                <span className='m-1'>{item.name}</span>
                                                <div
                                                    className={classNames(
                                                        item.current ? 'visible' : 'invisible',
                                                        'w-2 h-2 bg-[#FFC700] rounded-sm'
                                                    )} >
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="absolute bg-white  w-full left-0 top-[80px] md:hidden ">
                        <div className="pb-3 space-y-1">
                            {navigation.map((item) => (
                                <Disclosure.Button
                                    key={item.name}
                                    as="a"
                                    href={item.href}
                                    className={classNames(
                                        item.current ? 'h-[32px] font-bold text-[32px]' : 'h-[24px] font-medium text-[24px]',
                                        'block px-5 py-10 font-Poppins leading-[100%] text-black'
                                    )}
                                    aria-current={item.current ? 'page' : undefined}
                                    onClick={setNavigationItem}
                                >
                                    <span className='flex items-center'>
                                        <div
                                            className={classNames(
                                                item.current ? 'visible' : 'invisible',
                                                'w-2 h-2 bg-[#FFC700] rounded-sm m-2'
                                            )} >
                                        </div>
                                        {item.name}
                                    </span>
                                </Disclosure.Button>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}
